export const isEmpresaMei = (empresa) => empresa?.porte === 99;
